import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NlfTabsComponent } from './nlf-tabs.component';
import { SVGModule } from '../svg/svg.module';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';
import { DirectivesModule } from 'src/app/directives/directives.module';

@NgModule({
  declarations: [NlfTabsComponent],
  imports: [
    CommonModule,
	SVGModule,
	IBEAdminModule,
	DirectivesModule
  ],
  exports: [
    NlfTabsComponent
  ]
})
export class NlfTabsModule { }
